<template>
  <el-dialog
    class="registerDialog"
    width="951px"
    :visible.sync="dialogIsShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :show-close="false"
    :lock-scroll="false"
  >
    <div class="dialog-box">
      <div class="dialog-box-left">
        <img class="register-log" src="../../../assets/img/registerLogo.png" />
        <div class="describe-box">
          <div class="describe-login">
            <p class="title"><span class="red">立即登录</span> 开启全网商机</p>
            <p>众多行业领先企业和500强企业的共同选择</p>
          </div>
          <div class="describe-tip">
            <div>
              <p class="title">2.2<span>亿+</span></p>
              <p>招投标数据</p>
            </div>
            <div>
              <p class="title">1500<span>万+</span></p>
              <p>累计用户</p>
            </div>
            <div>
              <p class="title">20<span>万+</span></p>
              <p>商机源头覆盖</p>
            </div>
          </div>
          <div class="describe-customer">
            客服热线：<span> {{ "400-688-2000" }}</span>
          </div>
        </div>
      </div>
      <div class="dialog-box-right">
        <img
          @click="closeDialog"
          v-if="step === 1"
          class="close-dialog"
          src="../../../assets/img/header/closeDialog.png"
        />
        <div v-show="step === 1">
          <div v-show="!isQRCode" class="quick-login">
            <div class="login-type">
              <div
                v-for="item in tabs"
                :key="item.value"
                class="tab"
                :class="{ 'active-tab': item.value === loginType }"
                @click="changeTab(item.value)"
              >
                {{ item.label }}
                <div class="tab-bottom-line"></div>
              </div>
            </div>

            <div v-if="loginType === 1">
              <el-form :key="loginType" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item prop="phoneNum">
                  <el-input
                    class="input-phone"
                    type="tel"
                    maxlength="11"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    placeholder="请输入手机号"
                    v-model="ruleForm.phoneNum"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item prop="verificationCode" class="send-code-box">
                  <el-input
                    class="input-code"
                    maxlength="6"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    placeholder="请输入验证码"
                    v-model="ruleForm.verificationCode"
                    clearable
                  ></el-input>
                  <el-button
                    class="send-code"
                    :disabled="disabled"
                    :style="{ cursor: disabled ? 'default' : 'pointer' }"
                    @click="sendCodeHandler('ruleForm')"
                    type="text"
                    >{{ sendCode }}
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="loginType === 2">
              <el-form
                :key="loginType"
                :model="passwordLoginForm"
                :rules="passwordLoginRules"
                ref="passwordLoginRuleForm"
                class="demo-ruleForm"
              >
                <el-form-item prop="username">
                  <el-input
                    class="input-phone"
                    ref="mobile"
                    v-model="passwordLoginForm.username"
                    placeholder="请输入用户名"
                    name="username"
                    type="text"
                    autocomplete="off"
                    clearable
                    @input="
                      () => {
                        passwordLoginForm.username = passwordLoginForm.username.replace(/\s+/g, '');
                      }
                    "
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" class="send-code-box">
                  <el-input
                    class="input-phone"
                    ref="password"
                    :key="passwordType"
                    v-model="passwordLoginForm.password"
                    :type="passwordType"
                    placeholder="请输入密码"
                    name="password"
                    autocomplete="off"
                    @keyup.enter.native="handlePasswordLogin"
                    @input="
                      () => {
                        passwordLoginForm.password = passwordLoginForm.password.replace(/\s+/g, '');
                      }
                    "
                  >
                    <span slot="suffix" class="show-pwd" @click="showPwd">
                      <i
                        class="iconfont"
                        :class="passwordType === 'password' ? 'icon-mimabukejian' : 'icon-I_mimakejian'"
                      />
                    </span>
                  </el-input>
                  <a :href="RESET_PASSWORD_URL" target="_blank" class="reset-password">忘记密码</a>
                </el-form-item>
              </el-form>
            </div>
            <div class="user-protocol">
              登录/注册即代表同意<a
                class="primary-color"
                :href="`${OLD_ONE_CENTER_URL}/register_xz.jsp`"
                target="_blank"
                >《千里马会员注册须知》</a
              >及<a class="primary-color" :href="`${NET_WORK_PRIVACY_POLICY}`" target="_blank">《千里马隐私政策》</a>
            </div>

            <div class="login-or-register" @click="handleLogin(loginType === 2 ? 'passwordLoginRuleForm' : 'ruleForm')">
              {{ loginType === 2 ? "立即登录" : "登录/注册" }}
            </div>
            <div class="switch-wx-btn" v-if="!loginConfig.hideQrCodeLogin" @click="switchLoginMode()">
              <img src="../../../assets/img/switch-wx-btn.svg" alt="" />
              微信扫码登录
            </div>
          </div>
          <div v-show="isQRCode" class="scan-code-login">
            <div class="use-scan-code-tip">微信扫码登录/注册</div>

            <div class="code-box">
              <div class="code-img" ref="qrCodeUrl"></div>
              <div v-if="tipStatus.timeout" class="scene-box">
                <div class="content">
                  <template v-if="tipStatus.timeout">
                    <p class="tip-text">二维码已失效</p>
                    <div class="refresh-btn" @click="refreshCode">刷新</div>
                  </template>
                </div>
              </div>
              <img class="border-born-img border-born-top-left" src="../../../assets/img/border-horn.png" />
              <img class="border-born-img border-born-top-right" src="../../../assets/img/border-horn.png" />
              <img class="border-born-img border-born-bottom-left" src="../../../assets/img/border-horn.png" />
              <img class="border-born-img border-born-bottom-right" src="../../../assets/img/border-horn.png" />
            </div>
            <div class="click-text switch-btn" v-if="!loginConfig.hideQrCodeLogin" @click="switchLoginMode()">
              切换登录方式
            </div>

            <div class="user-protocol">
              登录/注册即代表同意<a
                class="primary-color"
                :href="`${OLD_ONE_CENTER_URL}/register_xz.jsp`"
                target="_blank"
                >《千里马会员注册须知》</a
              >及<a class="primary-color" :href="`${NET_WORK_PRIVACY_POLICY}`" target="_blank">《千里马隐私政策》</a>
            </div>
          </div>
        </div>
        <transition name="el-zoom-in-center">
          <DialogInformationImprove
            v-if="step === 2"
            @close="dialogInformationImproveClose"
            @success="dialogInformationImproveSuccess"
          />
        </transition>
      </div>
    </div>

    <!-- 多个账号选择框 -->
    <MultipleAccountsDialog
      :MultipleAccountList="MultipleAccountList"
      v-if="isMultipleAccounts"
      :phone="ruleForm.phoneNum"
      @close="isMultipleAccounts = false"
      @goLogin="goLogin"
    />
  </el-dialog>
</template>

<script>
import { phoneNumValid, CodeValid, allBlankSpaceValid } from "../../../utils/verificationRules";
import {
  restUApiMemberHomeSendSmsSliding,
  restUApiUserNewWebLogin,
  restUApiUserPhoneLogin,
  restUApiMemberHomeGetUsers,
  restULoginQrCodeUnionIdLogin,
  restULoginQrCodeGetLoginQrCodeState,
} from "../../../services/home";
import { restBuryPointUserBehaviorInsertRegistType } from "../../../services/register";
import { CookieKeys, Cookies } from "../../../utils/cookieKey";
import { restUCompanyGetCompanyInfo } from "../../../services/home";
import { RESET_PASSWORD_URL, OLD_ONE_CENTER_URL, NET_WORK_PRIVACY_POLICY } from "../../../utils/constants/constants";
import MultipleAccountsDialog from "./MultipleAccountsDialog.vue";
import { clearCookies, hasBid ,endsWithNumber0to4} from "../../../utils/common";
import QRCode from "qrcodejs2-fix";
import { DEED_MAP, OID_MAP } from "../../../utils/constants/constants.track";
import DialogInformationImprove from "../DialogInformationImprove";
import _ from "lodash";

const debounce = _.debounce((params, func) => {
  func(params);
}, 300);

export default {
  name: "DialogLogin",

  components: {
    MultipleAccountsDialog,
    DialogInformationImprove,
  },
  props: {
    dialogVisible: {
      default: false,
    },
  },
  computed: {
    isShowDialogInformationImprove() {
      return this.$store.getters["basic/isShowDialogInformationImprove"];
    },
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    isShowDialogInformationImproveFrom() {
      return this.$store.getters["basic/isShowDialogInformationImproveFrom"];
    },
    loginConfig() {
      return this.$store.getters["basic/loginConfig"];
    },
    loginSuccessGo() {
      return this.$store.getters["basic/loginSuccessGo"];
    },
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!phoneNumValid(value)) return callback(new Error(rule.message));
      callback();
    };
    const checkCode = (rule, value, callback) => {
      if (!CodeValid(value)) return callback(new Error(rule.message));
      callback();
    };
    const validAllBlankSpaceValid = (rule, value, callback) => {
      if (allBlankSpaceValid(value)) return callback(new Error(rule.message));
      callback();
    };

    return {
      hasBid,
      // 忘记密码url
      RESET_PASSWORD_URL,
      dialogIsShow: false,
      OLD_ONE_CENTER_URL,
      NET_WORK_PRIVACY_POLICY,
      // 登录类型 1手机号登录 2密码登录
      loginType: 1,
      step: 1,
      tabs: [
        {
          value: 1,
          label: "快捷登录",
        },
        {
          value: 2,
          label: "密码登录",
        },
      ],
      ruleForm: {
        phoneNum: "",
        verificationCode: "",
      },
      rules: {
        phoneNum: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: checkPhone,
            message: "请输入正确的手机号码 ",
            trigger: "blur",
          },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            validator: checkCode,
            message: "请输入6位数字验证码 ",
            trigger: "blur",
          },
        ],
      },
      sendCode: "发送验证码",
      disabled: false,
      // 密码登录表单
      passwordLoginForm: {
        username: "",
        password: "",
      },
      // 密码登录校验规则
      passwordLoginRules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          { min: 2, max: 50, message: "用户名长度2-50个字符", trigger: "blur" },
          // 自定义校验规则
          {
            validator: validAllBlankSpaceValid,
            message: "用户名不能全为空格 ",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度6-20个字符", trigger: "blur" },
          {
            validator: validAllBlankSpaceValid,
            trigger: "blur",
            message: "密码不能全为空格 ",
          },
        ],
      },
      // 多账号选择显隐
      isMultipleAccounts: false,
      // 多账号列表
      MultipleAccountList: [],
      // 密码星 不星
      passwordType: "password",
      timer: null,
      // 是否是快捷登录
      isQRCode: true,
      // 提示状态
      tipStatus: {
        timeout: false,
      },
      // 二维码定时器
      codeStatusTimer: null,
      // 生成二维码实例
      qrCode: null,
      // 获取二维码信息
      getLoginQrCodeInfo: {},
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.dialogIsShow = val;
        if (val && this.step === 1 && !this.isShowDialogInformationImprove) {
          this.isQRCode = this.loginConfig.defaultLoginType;
          if (this.hasBid()) {
            this.isQRCode = endsWithNumber0to4( Cookies.get(CookieKeys.qlmVisitorId));
            window.IS_QR_CODE = this.isQRCode;
            window.DEFAULT_REG_POP_TYPE =  this.isQRCode?1:2;
            this.setPointRegistType(1)
          }
          this.changeTab(1);
          this.$nextTick(() => {
            this.refreshCode();
          });
          this.$track(DEED_MAP.EXPOSURE, OID_MAP.LOGIN_POPUP_EXPOSURE);
        } else {
          this.clearCodePolling();
        }

      },
      immediate: true,
      deep: true,
    },
    loginConfig: {
      handler(val) {
        this.isQRCode = val.defaultLoginType;
        if (this.hasBid()) {
            this.isQRCode = endsWithNumber0to4( Cookies.get(CookieKeys.qlmVisitorId));
            window.IS_QR_CODE = this.isQRCode;
            window.DEFAULT_REG_POP_TYPE =  this.isQRCode?1:2;
          }
      },
      deep: true,
      immediate: true,
    },
    isShowDialogInformationImprove: {
      //打开完善信息页
      handler(val) {
        if (!val) return;
        this.step = 2;
      },
      deep: true,
      immediate: true,
    },
    step: {
      handler(val) {
        if (val === 2) {
          this.$track(DEED_MAP.EXPOSURE, OID_MAP.INFORMATION_IMPROVE_EXPOSURE);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 密码星 不星
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    closeDialog() {
      // 重置状态
      this.dialogIsShow = false;
      this.clearCodePolling();
      this.$refs.qrCodeUrl.innerHTML = "";
      this.step = 1;
      console.log(window.IS_QR_CODE);
      localStorage.setItem("isEjected", true);
      this.$store.commit("basic/updateIsShowDialogLogin", false);
      this.$emit("closeDialog");
    },
    async handleRegister(formName) {
      //去注册或登录
      this.$refs[formName].validate(async (valid) => {
        // 为表单绑定验证功能
        if (valid) {
          try {
            const res = await restUApiMemberHomeGetUsers({
              phone: this.ruleForm.phoneNum,
              code: this.ruleForm.verificationCode,
            }).then((res) => res);

            const data = res.data;

            if (data.length > 1) {
              //多个数据弹出选择框
              this.isMultipleAccounts = true;
              this.MultipleAccountList = data;
              return;
            }

            if (data.length === 1) {
              // 一条数据直接登录
              this.goLogin(data[0]);
              return;
            }

            if (res.code === 100008) {
              this.rules.verificationCode.push({
                validator: (rule, value, callback) => {
                  return callback(new Error(res.msg));
                },
              });
              this.$refs.ruleForm.validateField("verificationCode");
              this.rules.verificationCode.pop();
              return;
            }

            this.$message.error(res.msg);
          } catch (error) {
            console.log(error);
            if (error.code === 102007 || error.code === 102008) {
              this.rules.verificationCode.push({
                validator: (rule, value, callback) => {
                  return callback(new Error(error.msg));
                },
              });
              this.$refs.ruleForm.validateField("verificationCode");
              this.rules.verificationCode.pop();
              return;
            }
            this.$message.error(error.msg);
          }
        }
      });
    },
    //发送验证码
    async sendCodeHandler(formName) {
      this.$refs[formName].validateField("phoneNum", async (valid) => {
        if (!valid) {
          this.disabled = true;
          const res = await restUApiMemberHomeSendSmsSliding({
            phone: this.ruleForm.phoneNum,
          })
            .then((res) => res)
            .catch((error) => error);
          if (res.code === 200) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
            });
            let countDown = 60;
            this.disabled = true;
            this.timer = setInterval(() => {
              if (countDown === 0) {
                this.sendCode = "发送验证码";
                this.disabled = false;
                clearInterval(this.timer);
              } else {
                this.sendCode = countDown + "s";
                countDown--;
              }
            }, 1000);
          } else {
            this.disabled = false;
            this.$message.error(res.msg);
          }
        }
      });
    },
    async getCompanyInfo() {
      const res = await restUCompanyGetCompanyInfo();
      const userInfo = res.data;
      this.$store.commit("basic/updateUserInfo", userInfo);
      Cookies.set(CookieKeys.userInfo, JSON.stringify(userInfo), {
        expires: 365,
        domain: ".qianlima.com",
      });
      //
      if ((!userInfo.zhiwu || !userInfo.linkName || !userInfo.dwmc) && userInfo.roleId === 1) {
        //登录或者注册后是否存在三个值

        this.step = 2;
      } else {
        this.dialogIsShow = false;
        this.$emit("loginAfterHandle");
        this.closeDialog();
      }
    },
    // 切换登录方式
    changeTab(val) {
      if (val === this.loginType) {
        return false;
      }
      this.resetState(val);
    },
    // 密码登录
    handlePasswordLogin(formName) {
      this.$refs[formName].validate(async (valid) => {
        // 为表单绑定验证功能
        if (valid) {
          clearCookies();
          const res = await restUApiUserNewWebLogin(this.passwordLoginForm)
            .then((res) => res)
            .catch((error) => error);
          if (res.code === 200) {
            switch (res.data.loginStatus) {
              case 200:
                this.loginSuccess(res);
                break;
              case 102000:
                this.passwordLoginRules.username.push({
                  validator: (rule, value, callback) => {
                    return callback(new Error(res.data.message));
                  },
                });
                this.$refs[formName].validateField("username");
                this.passwordLoginRules.username.pop();
                break;
              default:
                this.passwordLoginRules.password.push({
                  validator: (rule, value, callback) => {
                    return callback(new Error(res.data.message));
                  },
                });
                this.$refs[formName].validateField("password");
                this.passwordLoginRules.password.pop();
            }
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
    handleLogin(formName) {
      if (formName === "passwordLoginRuleForm") {
        this.handlePasswordLogin(formName);
      } else {
        this.handleRegister(formName);
      }
    },
    // 登录成功处理逻辑
    loginSuccess(res) {
      Cookies.set(CookieKeys.qlm_username, res.data.username, {
        expires: 365,
        domain: ".qianlima.com",
      });
      Cookies.set(CookieKeys.qlm_password, res.data.password, {
        expires: 365,
        domain: ".qianlima.com",
      });
      this.getCompanyInfo();
    },
    // 多账号选择登录
    async goLogin(item) {
      clearCookies();
      if (item.isNewRegister) {
        const extendInfo = {
          url: window.location.href,
          userName: item.userName,
        };
        this.$track(DEED_MAP.CLICK, OID_MAP.NEW_HOME_REGISTER, {
          extendinfo: JSON.stringify(extendInfo),
        });
        if (this.loginSuccessGo.trackData) {
          const trackData = this.loginSuccessGo.trackData;
          this.$track(DEED_MAP.CLICK, trackData.oid, {
            extendinfo: JSON.stringify({
              ...extendInfo,
              ...trackData,
            }),
          });
        }
        this.setPointRegistType(3)
      }
      restUApiUserPhoneLogin({
        username: item.userName,
        password: item.code,
      }).then((res) => {
        if (res.code === 200) {
          this.loginSuccess(res);
        } else if (res.code && res.code !== 200 && res.msg) {
          this.$message.error(res.msg);
        }
      });
    },
    // 重置状态
    resetState(val = "") {
      this.loginType = val;
      if (val === 1) {
        this.ruleForm = {
          phoneNum: "",
          verificationCode: "",
        };
        this.sendCode = "发送验证码";
        this.disabled = false;
        clearInterval(this.timer);
      } else if (val === 2) {
        this.passwordLoginForm = {
          username: "",
          password: "",
        };
      }

      this.clearCodePolling();
    },
    // 切换登录方式
    switchLoginMode(val = 1) {
      this.isQRCode = !this.isQRCode;
      if (this.hasBid()) {
        window.IS_QR_CODE = this.isQRCode;
        window.IS_ONCLICK_CHANGE = true;
        this.setPointRegistType(2)
      }
      if (!this.isQRCode) {
        this.clearCodePolling();
        this.resetState(val);
        this.$nextTick(() => {
          this.$refs[val === 1 ? "ruleForm" : "passwordLoginRuleForm"].resetFields();
        });
      } else {
        this.clearCodePolling();
        console.log(222);

        this.refreshCode();
      }
    },
    async getLoginQrCodeState() {
      const { clientId, sign, expireTime } = this.getLoginQrCodeInfo;
      if (!this.isQRCode || !this.dialogIsShow) {
        this.clearCodePolling();
        return false;
      }
      const { status, cookieDto } = await restULoginQrCodeGetLoginQrCodeState({
        clientId,
        sign,
        expireTime,
      }).then((res) => res.data);
      if (["NOT_SCANNED", "SCANNED"].includes(status)) {
        this.codeStatusTimer = setTimeout(() => {
          this.codePolling();
        }, 1000);
      } else if (status === "EXPIRED") {
        this.tipStatus.timeout = true;
        this.clearCodePolling();
      } else if (status === "REDIRECT") {
        this.clearCodePolling();
        this.$message.error("手机号已注册，请使用账号密码登录！");

        this.switchLoginMode(2);
      } else if (status === "LOGGED") {
        this.clearCodePolling();

        const { code, username, isNewRegister } = cookieDto;
        this.goLogin({ code, userName: username, isNewRegister });
      }
    },
    // 二维码轮询
    codePolling() {
      this.getLoginQrCodeState();
    },
    // 获取小程序二维码接口
    async restULoginQrCodeUnionIdLogin() {
      try {
        this.getLoginQrCodeInfo = await restULoginQrCodeUnionIdLogin().then((res) => res.data);
        this.createQrCode(this.getLoginQrCodeInfo.loginQrCodeImageUrl);
        this.codePolling();
      } catch (error) {
        console.log("获取小程序二维码接口请求失败：" + error);
      }
    },
    // 生成二维码
    createQrCode(url) {
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = "";
        this.qrCode = new QRCode(this.$refs.qrCodeUrl, {
          text: url, // 需要转换为二维码的内容
          width: 182,
          height: 182,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.$refs.qrCodeUrl.title = ""; // 删除标题属性
      });
    },
    // 刷新二维码
    refreshCode() {
      console.log(111);

      this.$refs.qrCodeUrl.innerHTML = "";
      console.log("刷新二维码", this.isQRCode);
      debounce({}, () => {
        this.tipStatus.timeout = false;
        if (this.isQRCode && this.step === 1 && this.dialogIsShow) {
          this.restULoginQrCodeUnionIdLogin();
        }
      });
    },
    // 清除二维码轮询定时
    clearCodePolling() {
      clearTimeout(this.codeStatusTimer);
      this.codeStatusTimer = null;
    },
    dialogInformationImproveClose() {
      if (this.isShowDialogInformationImproveFrom === "afterPageLoad") {
        //只是弹出了完善信息
        this.closeDialog();
      } else {
        localStorage.setItem("isEjected", true);
        sessionStorage.setItem("onRegister", true);
        this.$emit("loginAfterHandle");
      }
    },
    dialogInformationImproveSuccess() {
      if (this.isShowDialogInformationImproveFrom === "afterPageLoad") {
        //只是弹出了完善信息
        this.closeDialog();
        return;
      }
      setTimeout(() => {
        localStorage.setItem("isEjected", true);
        this.$emit("loginAfterHandle");
      }, 1000);
    },
    setPointRegistType(oid) {
      restBuryPointUserBehaviorInsertRegistType({
        oid,
        regPopType: window.DEFAULT_REG_POP_TYPE,
        hadChangeRegType:window.IS_ONCLICK_CHANGE?'是':'否',
        regType:  window.IS_QR_CODE?1:2,
        urlType: "bid",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/config";

.primary-color {
  color: $theme-color;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 2px;

  cursor: pointer;

  i.icon-mimabukejian {
    font-size: 12px;
    display: inline-block;
    transform: scale(0.68);
  }

  i.icon-I_mimakejian {
    font-size: 14px;
    display: inline-block;
    //transform: scale(0.68);
  }
}

.registerDialog {
  .register-log {
    width: 86px;
    height: 49px;
    margin: 32px 0 0 0;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .input-phone,
  .input-code {
    width: 355px;
    height: 44px;
  }

  .send-code-box {
    position: relative;
    display: flex;
    align-items: center;
    margin: 28px 0 40px 0;

    .send-code {
      width: 88px;
      position: absolute;
      right: 12px;
      color: $theme-color;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      top: 2px;
      font-weight: 400;
      padding-left: 10px;
    }

    .send-code::before {
      content: "";
      background-color: #d0d5dc;
      width: 1px;
      height: 20px;
      display: inline-block;
      position: absolute;
      left: 0;
    }
  }

  .login-or-register {
    width: 355px;
    height: 44px;
    background-color: $theme-color;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 28px;
    font-weight: 550;

    &:hover {
      background-color: #f66d59;
    }
  }

  .user-protocol {
    color: #a3a6ab;
    font-size: 12px;
    margin: 19px 0 17px 0;

    .primary-color {
      color: $theme-color;
    }
  }

  .user-protocol a {
    color: #a3a6ab;
    font-size: 12px;
  }

  .user-protocol a:hover {
    color: $theme-color;
    text-decoration: underline;
  }

  .close-dialog {
    position: absolute;
    width: 13px;
    top: 32px;
    right: 30px;
    cursor: pointer;
  }

  .login-type {
    display: flex;
    width: 100%;
    font-size: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #45464a;
    line-height: 27px;
    position: relative;
    margin-bottom: 34px;
    padding-left: 58px;

    .tab {
      text-align: center;
      padding-bottom: 10px;
      cursor: pointer;
      position: relative;
      width: 72px;
      margin-right: 76px;

      .tab-bottom-line {
        width: 72px;
        height: 3px;
        background: transparent;
        position: absolute;
        bottom: 6px;
        left: 0%;
      }
    }

    .active-tab {
      color: $theme-color;
      font-weight: 550;

      .tab-bottom-line {
        background: $theme-color;
      }
    }
  }

  .reset-password {
    position: absolute;
    top: 42px;
    right: 0;
    color: #666666;
    font-size: 11px;
    line-height: 38px;
  }
}

.switch-login-type-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 52px;
  height: 47px;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.click-text {
  cursor: pointer;
}

.dialog-box {
  display: flex;

  .dialog-box-left {
    width: 500px;
    height: 522px;
    padding-left: 32px;
    background: url("../../../assets/img/register-bg.png") no-repeat;
    background-size: cover;

    .describe-box {
      padding-left: 16px;

      .red {
        color: $theme-color !important;
      }

      .describe-login {
        padding-top: 40px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #797c81;
        line-height: 22px;
        letter-spacing: 1.5px;

        .title {
          font-size: 32px;
          font-family: Helvetica, Helvetica-Regular;
          font-weight: 600;
          text-align: left;
          color: #2a2b33;
          line-height: 38px;
          padding-bottom: 6px;
          letter-spacing: 0;
        }
      }

      .describe-tip {
        margin-top: 32px;
        display: flex;
        width: 332px;
        justify-content: space-between;

        & > div {
          display: flex;
          flex-flow: column;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 20px;

          .title {
            font-size: 30px;
            font-family: DIN Alternate, DIN Alternate-Bold;
            font-weight: 700;
            text-align: left;
            color: #2a2b33;
            line-height: 35px;

            span {
              font-size: 16px;
            }
          }
        }
      }

      .describe-customer {
        margin-top: 48px;

        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #787c82;
        line-height: 28px;

        span {
          color: #f15748;
          font-family: DIN Alternate Bold;
          font-weight: 600;
        }
      }
    }
  }

  .dialog-box-right {
    padding-top: 32px;
    width: 366px;
    margin-left: 48px;

    .quick-login {
      padding-top: 49px;

      ::v-deep .el-input__inner {
        height: 44px;
        border-radius: 4px;
        padding-right: 32px;
      }

      .send-code-box {
        ::v-deep .el-input__inner {
          padding-right: 40px;
        }
      }
    }

    .scan-code-login {
      padding-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .use-scan-code-tip {
        font-size: 18px;
        font-weight: 550;
        color: #45464a;
        line-height: 25px;
      }

      .code-box {
        margin-top: 30px;
        margin-bottom: 48px;
        width: 210px;
        height: 210px;
        background: #ffffff;
        border: 2px solid #e9edfa;
        position: relative;

        .scene-box {
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333333;
          position: absolute;
          top: 0;

          .content {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .refresh-btn {
            margin-top: 15px;
            width: 100px;
            height: 32px;
            background: $theme-color;
            border-radius: 4px;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
            color: #fff;

            &:hover {
              background: #fd7e6c;
            }
          }

          .scan-code-success {
            margin-bottom: 12px;
          }

          .tip-text {
            font-size: 16px;
            font-weight: 550;
            color: #333333;
          }
        }

        .border-born-img {
          position: absolute;
          width: 9px;
          height: 9px;
        }

        .border-born-top-left {
          top: -2px;
          left: -2px;
        }

        .border-born-top-right {
          top: -2px;
          right: -2px;
          transform: rotate(90deg);
        }

        .border-born-bottom-left {
          bottom: -2px;
          left: -2px;
          transform: rotate(270deg);
        }

        .border-born-bottom-right {
          bottom: -2px;
          right: -2px;
          transform: rotate(180deg);
        }
      }

      .code-img {
        margin-top: 13px;
        margin-left: 13px;
      }
    }

    .switch-btn {
      width: 84px;
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: center;
      color: #2a2b33;
      line-height: 20px;

      &:hover {
        color: $theme-color;
        font-weight: 550;
      }
    }

    .switch-wx-btn {
      width: 355px;
      display: flex;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 20px;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:hover {
        color: $theme-color;
        font-weight: 550;
      }

      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.registerDialog {
  display: flex;
  align-items: center;

  .el-dialog {
    margin-top: 0 !important;
    border-radius: 0px;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.4);

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      //display: flex;
      //flex-direction: column;
      //align-items: center;
      padding: 0;

      .el-input__inner {
        //height: 44px;
        border-radius: 4px;
      }

      .input-code .el-input__inner {
        padding-right: 160px;
        margin-right: 20px;
      }

      .el-input__icon {
        margin-top: 2px;
      }

      .input-code .el-input__icon {
        margin-right: 100px;
      }
    }

    .el-form-item__error {
      padding-top: 8px;
    }
  }
}
</style>
